import { render } from "./PeriodTree.vue?vue&type=template&id=48b6b0ce&scoped=true"
import script from "./PeriodTree.vue?vue&type=script&lang=js"
export * from "./PeriodTree.vue?vue&type=script&lang=js"

import "./PeriodTree.vue?vue&type=style&index=0&id=48b6b0ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b6b0ce"]])

export default __exports__